import { createContext, useContext, useState, useEffect, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, object=auth
  const [glossary, setGlossary] = useState([]);

  const loadGlossary = useCallback(async () => {
    try {
      const { data } = await api.get("/glossary");
      setGlossary(data);
    } catch (e) { /* not approved yet */ }
  }, []);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch (e) {
      setUser(null);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) return; // AuthCallback handles it
    checkAuth();
  }, [checkAuth]);

  useEffect(() => {
    if (user && user.status === "approved") loadGlossary();
  }, [user, loadGlossary]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("ao_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (e) {}
    localStorage.removeItem("ao_token");
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, checkAuth, glossary, loadGlossary }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
